import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  getStates,
  getNotifications,
  markOneSeen,
  markAllSeen,
} from '~/services/dashboard'
import { updateNotification } from '~/store/app/slice'
import { NotificationTypes } from '~/store/app/types'

export default function useStats() {
  const [statsData, setStatsData] = useState<any>()
  const [loading, setLoading] = useState(false)
  const [notifications, setNotifications] = useState<any>([])
  const dispatch = useDispatch()
  const notificationCount = localStorage.getItem("userNotification");

  const fetchStats = async () => {
    setLoading(true)
    try {
      const { data } = await getStates()
      setStatsData(data)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const fetchNotifications = async () => {
    setLoading(true)
    try {
      const data = await getNotifications()
      setNotifications(data)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const markNotificationAsSeen = async (id: any) => {
    setLoading(true)
    try {
      const response = await markOneSeen(id)
      fetchNotifications()
      dispatch(
        updateNotification({
          text: response?.data?.message,
          type: NotificationTypes.SUCCESS,
        })
      )
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const markAllNotificationsSeen = async () => {
    setLoading(true)
    try {
      const response = await markAllSeen()
      fetchNotifications()
      dispatch(
        updateNotification({
          text: response?.data?.message,
          type: NotificationTypes.SUCCESS,
        })
      )
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchStats()
    fetchNotifications()
  }, [notificationCount])

  return {
    statsData,
    loading,
    notifications,
    markNotificationAsSeen,
    markAllNotificationsSeen,
  }
}
